import React, {PureComponent, ReactNode} from "react";

import Logo from "../../../../public/assets/images/mehrmarkencenterSmall.webp";

export class Mehrmarkencenter extends PureComponent {

    render(): ReactNode {

        return (
            <div className={'col-span-2 p-1 text-xs leading-4 lg:text-base lg:leading-6 font-normal'}>
                    <img
                        loading={'lazy'}
                        src={Logo.src}
                        alt="Mehrmarkencenter"
                        className={'!w-[25px]'}
                    />
            </div>
        );
    }
}